import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../utils/activityCenter';

const TaskTimestamp = ({ createdAt }) => {
  const { t } = useTranslation();

  return (
    <Typography variant="caption" color="textSecondary">
      {t('Label_CreatedOn')}: {formatDateTime(createdAt)}
    </Typography>
  );
};

export default TaskTimestamp;
